import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Checkbox,
  Container,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TextField,
  createTheme,
  Button,
  TablePagination
} from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import Alert from 'src/components/Alert';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import trLocale from 'date-fns/locale/tr';

import { Stack } from '@mui/material';
import axios from 'src/utils/axios';

import SearchIcon from '@mui/icons-material/Search';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PrintIcon from '@mui/icons-material/Print';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PersonAddIcon from '@mui/icons-material/PersonAdd';


const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};



function JointService() {
  const useStyles = makeStyles(theme => ({
    root: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    rootlist: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      maxHeight: 550
    },
    rootlistsag: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      position: 'relative',
      overflow: 'auto',
      maxHeight: 500
    },

    cardBolum: {
      maxHeight: 700,
      minHeight: 700,
      width: '100%'
    },
    table: {
      minWidth: 650
    },
    content: {
      minHeight: 550
    },
    chatSection: {
      width: '100%'
    },
    avatar: {
      cursor: 'pointer',
      width: 40,
      height: 40
    },
    headBG: {
      backgroundColor: '#e0e0e0'
    },
    borderRight500: {
      borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
      overflowY: 'auto'
    },
    button: {
      margin: theme.spacing(1)
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    actionsCCFile: {
      justifyContent: 'flex-end'
    },
    responsiveContainer: {
      marginTop: theme.spacing(3),
      [theme.breakpoints.between('md', 'lg')]: {
        maxHeight: '70vh',
        overflowX: 'hidden',
        overflowY: 'scroll'
      },
      [theme.breakpoints.down('sm')]: {
        maxHeight: '60vh',
        overflow: 'scroll'
      }
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: 10,
      borderRadius: 10,
    },
    switch_track: {
      backgroundColor: "#263238",
    },
    switch_base: {
      color: '#FF9800',
      "&.Mui-disabled": {
        color: '#FF9800'
      },
      "&.Mui-checked": {
        color: "#FF9800"
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#263238",
      }
    },
    switch_primary: {
      "&.Mui-checked": {
        color: "#263238",
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#263238",
      },
    },

  }));

  const theme = useTheme();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const SessionUser = getUser();

  const [responseMessage, setresponseMessage] = useState(
   "" 
  );

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = React.useState(null);


  const [employeeReportData, setEmployeeReportData] = React.useState([]);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(10);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;

  const SelectAllOption = { Id: -1, Dsc: 'Tümünü Seç' };
  const [openDialog, setOpenDialog] = React.useState(false);
  useEffect(() => {
    getBolgeAdiKoduData();

  }, []);

  const [Bolge, setBolge] = useState([]);
  const [Servis, setServis] = useState('');
  const [JointServis, setJointServis] = useState('');
  const [JointRate, setJointRate] = useState('');
  const [Desc, setDesc] = useState('');

  const handleSaveData = (OperationType) => {
 
    const requestData = {
      "Bolge": Bolge[0].BirimKodu,
      "ServiceKulCode":  selectedRowForEdit ? selectedRowForEdit.SERVIS_KODU : Servis.BirimKodu,
      "JointServiceKulCode":  selectedRowForEdit ? selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS_KODU : JointServis,
      "JointRate": JointRate,
      "Description": Desc,
      "Type" : OperationType

    };
    //Servis,JointService,JointRate,Desc,requestData);
    // Make the API call using Axios
    axios.post('SetServiceJoint', requestData)
      .then(response => {
        if(response.data.ErrorCode == 0 )
        {
          setUyariTip("success");
        }
        else
        {
          setUyariTip("error");
        }
        setresponseMessage(response.data.ErrorDescription);
        setUyari(true);
  
        // Reset input fields after successful submission if needed
        setBolge(bolgeAdiKodu.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
        setServis('');
        setJointServis('');
        setJointRate('');
        setDesc('');
        // ... reset other fields if needed
      })
      .catch(error => {
        setUyariTip("error");
        setresponseMessage("Bir hata meydana geldi, daha sonra tekrar deneyiniz.");
        setUyari(true);
      });
  }


  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(response?.data?.filter(x => x?.BirimKodu !== '0'));
      setSelectedbolgeAdiKodu(response?.data?.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
      getBirimData([SessionUser.TopServiceShopCode]);
      setBolge(response?.data?.filter(x => x?.BirimKodu == SessionUser.TopServiceShopCode));
    })

  }

  const getBirimData = (BirimKodu) => {
    if (!BirimKodu || BirimKodu.length < 1) {
      setBirimData([]);
    } else {
      setLoading(true);
      axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
        setBirimData(response.data);
        setLoading(false);
      });
    }
  }


  const getReport = () => {
    setLoading(true);
    const birimKoduQuery = !SelectedBirim || SelectedBirim.length < 1 ? '0' : SelectedBirim?.map(x => x.BirimKodu).join("&BirimKodu=");
    const bolgeKoduQuery = !selectedbolgeAdiKodu || selectedbolgeAdiKodu.length < 1 ? '0' : selectedbolgeAdiKodu?.map(x => x.BirimKodu).join("&BolgeKodu=");
    axios.get(`GetServiceJoint?BolgeKodu=${bolgeKoduQuery}&BirimKodu=${birimKoduQuery}`).then((response) => {
      setEmployeeReportData(response.data);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
    });
  }

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const clearAllInputs = () => {
    setSelectedbolgeAdiKodu([]);
    setSelectedBirim([]);
    setEmployeeReportData([]);
    setpg(0);
    setrpg(10);
  }



  const renderOption = (props, option, { selected }) => (
    option.Id !== -1 ?
      (<li {...props}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
      : (<li {...props}>
        <Checkbox
          icon={selectAllIcon}
          checkedIcon={selectAllIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
  );
  const handleOpenNewApplicationDialogUser = () => {
    
    setOpenDialog(true);
    


  };

  const handleCloseNewApplicationDialogUser = () => {
    setOpenDialog(false);
  };

  const handleUpdateClick = (row) => {
    setSelectedRowForEdit(row);
    setOpenEditDialog(true);
  };

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container className={classes.container1} maxWidth="xl">
        <Card>
          <CardHeader title="Nakliye Montaj Servisleri" />
          <Divider />
          <CardContent>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<PersonAddIcon />}
              onClick={handleOpenNewApplicationDialogUser}
              style={{ textTransform: 'none', marginRight: 18 }}
            >
              Yeni Servis Ekle
            </Button>

            <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} fullWidth maxWidth="lg">
      <DialogTitle>Edit Entry</DialogTitle>
      <DialogContent>
        {selectedRowForEdit && (
          <div>
            <TextField
              fullWidth
              label="Bölge"
              variant="outlined"
              margin="normal"
              value={selectedRowForEdit.BOLGE || ""}
              disabled
            />
            <TextField
              fullWidth
              label="Servis"
              variant="outlined"
              margin="normal"
              value={selectedRowForEdit.SERVIS || ""}
              disabled
            />
            <TextField
                  fullWidth
                  label="Nakliye Montaj Servis Kodu"
                  variant="outlined"
                  margin="normal"
                  value={selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS_KODU}
                 disabled
                />
            <TextField
                  fullWidth
                  label="Nakliye Montaj Servis"
                  variant="outlined"
                  margin="normal"
                  value={selectedRowForEdit.NAKLIYE_MONTAJ_SERVIS}
                 disabled
                />
            <TextField
                  fullWidth
                  label="Ortaklık Pay"
                  variant="outlined"
                  margin="normal"
                  value={JointRate}
                  onChange={(e) => setJointRate(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Not"
                  variant="outlined"
                  margin="normal"
                  value={Desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
           
            
           
          </div>
          
        )}
      </DialogContent>
      <DialogActions>
                <Button onClick={handleCloseNewApplicationDialogUser} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleSaveData('U');
                    setOpenDialog(false);
                  }}
                  color="primary"
                >
                  Confirm
                </Button>
              </DialogActions>
    </Dialog>

            <Dialog open={openDialog} onClose={handleCloseNewApplicationDialogUser} fullWidth
              maxWidth="lg">
              <DialogTitle>Yeni Servis Ekle</DialogTitle>
              <DialogContent>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={Bolge}
                  options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    setBolge(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                  disabled
                />

                <Autocomplete

                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={Servis}
                  options={BirimData}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  onChange={(event, newValue) => {
                    setServis(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
                />
                <TextField
                  fullWidth
                  label="Nakliye Montaj Servis Kodu"
                  variant="outlined"
                  margin="normal"
                  value={JointServis}
                  onChange={(e) => setJointServis(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Ortaklık Pay"
                  variant="outlined"
                  margin="normal"
                  value={JointRate}
                  onChange={(e) => setJointRate(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Not"
                  variant="outlined"
                  margin="normal"
                  value={Desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
                
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseNewApplicationDialogUser} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleSaveData('I');
                    setOpenDialog(false);
                  }}
                  color="primary"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            <Grid container spacing={2}>
              <Grid item xs={12}>


                <Stack direction="row" spacing={1}>
                  <Button
                    className={classes.action}
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      getReport();
                    }}
                  >
                    ARA
                    <SearchIcon style={{ marginLeft: '5px' }} />
                  </Button>

                </Stack>
              </Grid>
              <Grid item xs={12} sm={12} lg={6} >
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu.length > 0 ? [SelectAllOption, ...bolgeAdiKodu] : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedbolgeAdiKodu(bolgeAdiKodu) : setSelectedbolgeAdiKodu(newValue);
                    var bolgeKodu = newValue?.find(x => x.Id == -1) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                    getBirimData(bolgeKodu);
                    setSelectedBirim([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size="small"
                  id="combo-box-demo"
                  fullWidth
                  value={SelectedBirim}
                  options={BirimData.length > 0 ? [SelectAllOption, ...BirimData] : []}
                  getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    newValue?.find(x => x.Id == -1) ? setSelectedBirim(BirimData) : setSelectedBirim(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                />
              </Grid>
            </Grid>
            <TableContainer className={classes.responsiveContainer}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead style={{ overflowWrap: 'break-word' }}>
                  <TableRow>
                    <TableCell align="left">""</TableCell>
                    <TableCell align="left">Bölge</TableCell>
                    <TableCell align="left">NM Servis Kodu </TableCell>
                    <TableCell align="left">NM Servis Adı</TableCell>
                    <TableCell align="left">Ortak</TableCell>
                    <TableCell align="left">Ortaklık Pay</TableCell>
                    <TableCell align="left">Ortaklık Başlangıç</TableCell>
                    <TableCell align="left">Ortaklık Bitiş</TableCell>
                    <TableCell align="left">NM Kapanış Tarihi</TableCell>
                    <TableCell align="left">Açıklama</TableCell>
                    <TableCell align="left">Log</TableCell>
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                  

                <TableBody>
                  {employeeReportData.length > 0 && employeeReportData.slice(pg * rpg, pg * rpg + rpg).map((row, index) => (
                    <TableRow
                      key={row.Id}
                      
                    >
                          <TableCell align="left">
                          <Button variant="outlined" color="primary" onClick={() => handleUpdateClick(row)}>
                          Düzenle
                        </Button>
                        </TableCell>
                      <TableCell align="left">{row.BOLGE || "-"}</TableCell>
                      <TableCell align="left">{row.NM_BIRIM_KODU || "-"}</TableCell>
                      <TableCell align="left">{row.NM_AD || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAK || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_PAY || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_BASLANGIC || "-"}</TableCell>
                      <TableCell align="left">{row.ORTAKLIK_BITIS || "-"}</TableCell>
                      <TableCell align="left">{row.NM_KAPANIS_TARIHI || "-"}</TableCell>
                      <TableCell align="left">{row.ACIKLAMA || "-"}</TableCell>
                      <TableCell align="left">{row.KULLANICI_LOG || "-"}</TableCell>
                      <TableCell align="left" />
                    </TableRow>
                  ))}

                </TableBody>
                    
              </Table>
            </TableContainer>
            {employeeReportData.length > 0 &&
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={employeeReportData.length}
                rowsPerPage={rpg}
                page={pg}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            }
          </CardContent>
        </Card>
      </Container>
    </Page >
  );
}
export default JointService;
